<template>
    <div class="bidding-enroll">
        <div class="bidding-info">
            <div class="info">
                <ul class="info-list">
                    <li class="info-item" v-for="servcGoodsCatRel in servcGoodsCatRelList">
                        <label>
                            <el-radio class="radio" v-model="servcGoodsCatRelId" :label="servcGoodsCatRel.id">{{servcGoodsCatRel.goodsCatName}}</el-radio>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import servcApi from '../../api/servc'

    export default {
        name: 'swb-servc-goods-cat-rel-list',
        avlScopes: 'servicer',
        desc: '服务与商品分类关联',
        props: ['merchantId', 'merchantType', 'servcId', 'type'],
        data: function () {
            return {
                servcGoodsCatRelList: [],
                servcGoodsCatRelId: {}
            }
        },
        created: function () {
            this.getServcGoodsCatRelList();

        },
        methods: {
            getServcGoodsCatRelList: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.merchantId;
                postData.merchantType = self.merchantType;
                postData.servcId = self.servcId;
                if(!Utils.isNoB(self.type)) {
                    postData.type = self.type;
                }
                servcApi.getServcGoodsCatRelList(postData, function (result) {
                    if(result.type == "info") {
                        self.servcGoodsCatRelList = result.data;
                    }
                })
            },
            getDlgResult: function () {
                let servcGoodsCatRelId = this.servcGoodsCatRelId;
                let result = {};
                let aa = this.servcGoodsCatRelList;
                let servcGoodsCatRel = aa.find(function (row) {
                    return row.id == servcGoodsCatRelId;
                });

                if(servcGoodsCatRel != null) {
                    result.data = servcGoodsCatRel;
                    result.type = "info";
                } else {
                    result.type = "warn";
                    result.message = "请选择对应的分类";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/ServcGoodsCatRelSelect.vue